import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UrlsService } from '../../Shared/Services/urls.service';
import { SharedHttpClientService } from '../../Shared/Services/shared-http-client.service';
import { Router } from '@angular/router';
import { UserService } from '../../Shared/Services/user.service';
import { SystemlogsummaryComponent } from './system-log-summary/system-log-summary.component';
import { TotalexceptionComponent } from './open-exception-details/exception-summary-count-list.component';
import { SummaryComponent } from './transaction-exception-summary/transaction-exception-summary.component';
import { ExceptioncountComponent } from './exceptioncount/exceptioncount.component';
import { TransactioncountComponent } from './transactioncount/transactioncount.component';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
@Component({
    selector: 'app-maindashboard',
    imports: [TotalexceptionComponent, SystemlogsummaryComponent, TransactioncountComponent, SummaryComponent, ExceptioncountComponent],
    templateUrl: './maindashboard.component.html',
    styleUrls: ['./maindashboard.component.scss']
})
export class MaindashboardComponent implements OnInit,AfterViewInit {
  ngAfterViewInit(): void {
    this.userService.getLastReportedDate();
    
  }

  constructor(private urlService: UrlsService,
    private userService: UserService,
    private router: Router,
    private authServiceService:AuthServiceService ) {
  }



  ngOnInit() {

  }

}
